import { render, staticRenderFns } from "./UserExpRule.vue?vue&type=template&id=3cb66510&"
import script from "./UserExpRule.vue?vue&type=script&lang=js&"
export * from "./UserExpRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports